<p-toast />
<section>
  <div class="background">
  </div>
  <div class="header">
    <div class="text">
      <h1>Create And Customizable 2D Maps<br> For Your Roblox Game</h1>
      <p>Go beyond simple screenshot maps with powerful editing tools.<br> Customize your maps to perfectly fit your game, no compromises.</p>
      <p-button
        icon="pi pi-sliders-h"
        label="Editor Demo"
        size="large"
        (onClick)="openDemo()"
      >
      </p-button>
    </div>
    <div
      #previewImage
      class="preview-image"
      data-tilt
      data-tilt-glare
      data-tilt-max-glare="0.1"
      data-tilt-reverse
      data-tilt-full-page-listening
      data-tilt-max="10"
      data-tilt-speed="400"
    >
      <iframe
        width="100%"
        height="100%"
        src="https://www.youtube.com/embed/nD_JneZu0DU?si=KS-IcipcDHes-AsM"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen
      ></iframe>
    </div>
  </div>
<section id="stats">
  <app-home-current-stats/>
</section>
<section id="features">
  <app-home-stepper />
</section>
<section id="reviews">
  <app-home-testimonials />
</section>
<section id="pricing">
  <app-home-pricing />
</section>
<section id="faq">
  <app-home-faq />
</section>
<section id="bottom-links">
  <app-home-bottom-links />
</section>
